export const programTypes = [
  "Copay Card",
  "Free Drug",
  "Copay Foundation",
  "Living and Transport expenses",
  "Government Plans",
  "Internal"
];

export const lookbackPeriodUnits = Object.freeze({
  months: "months",
  days: "days"
});

export const LOOKBACK_INPUT_MODES = Object.freeze({
  period: "period",
  date: "date"
});

// Lookback period UI constants (used across Track tab)
export const LOOKBACK_VALUE_OTHER = "other";
export const LOOKBACK_DAYS_OPTIONS = Object.freeze([0, 30, 60, 90, 120, 150, 180]);
export const LOOKBACK_MONTHS_OPTIONS = Object.freeze([3, 4, 6]);
